function concatAddress2(address?: string) {
	return `${address ? ` ${address}` : ""}`;
}

function isIndividual(customerType: string) {
	return customerType === "individual";
}

function isBusiness(customerType: string) {
	return customerType === "business";
}

export { concatAddress2, isIndividual, isBusiness };
